import React from 'react';

import styled from 'styled-components';

import { isAllDay, showTime } from '@libs/NwMoment';

import { forceReloadFollowup } from '@hooks/API/Event/UseFollowup';

import { EventCommentsDocuments } from '@components/EventDrawer/EventDrawerUi/EventCommentsDocuments';
import { EventDetailsWrapper } from '@components/EventDrawer/EventDrawerUi/EventUI';
import ResponsiveFlexContainer from '@components/Gui/ResponsiveFlexContainer';

import { ACTIONS, useFollowUp } from './FollowUpContext';
import { FollowUpGroupInstanceModelNameAndDate } from './FollowUpGroupInstanceModelNameAndDate';

const InstanceWrapper = styled.div`
    &.is-cancelled {
        opacity: 0.5;
    }
`;

const FollowUpGroupInstanceDetails = ({ event, onTouchForm, hideDescription = false, hideTime = false }) => {
    const { plainMode, followUpData, groupType, addCommentForEventId, dispatch } = useFollowUp();

    const FollowUpRelatedEvents = followUpData.RelatedEvents
        ? [followUpData, ...followUpData.RelatedEvents]
        : [followUpData];

    const handleUpdateFollowUps = () => {
        forceReloadFollowup(followUpData.ID);
        FollowUpRelatedEvents.forEach((e) => forceReloadFollowup(e.ID));
    };

    const getUploadEndpoint = () => {
        let endpoint = `documents/upload/1?followUpID=${event.ID}`;
        if (event.Project) {
            endpoint += `&projectID=${event.Project.ID}`;
        }
        if (event.ModelID) {
            endpoint += `&contactID=${event.ModelID}`;
        }
        return endpoint;
    };

    const firstColumnWidth = '8rem';

    return (
        <InstanceWrapper className={event.Cancel ? 'is-cancelled' : null}>
            <FollowUpGroupInstanceModelNameAndDate
                event={event}
                uploadEndpoint={getUploadEndpoint()}
                onUploadEnd={handleUpdateFollowUps}
            />
            <EventDetailsWrapper $padding="0 2rem .25rem 4rem" className={event.Cancel ? 'is-cancelled' : null}>
                {groupType !== 'period' && !hideTime && (
                    <ResponsiveFlexContainer
                        columns={[
                            {
                                content: <p className="is-label">Time</p>,
                                width: firstColumnWidth,
                                isBorder: true,
                            },
                            {
                                content: isAllDay(event.StartDate, event.EndDate) ? (
                                    <p className="is-content">All Day</p>
                                ) : (
                                    <p className="is-content">{`${showTime(event.StartDate)} > ${showTime(event.EndDate)}`}</p>
                                ),
                                isBorder: false,
                            },
                        ]}
                    />
                )}
                {!hideDescription && (
                    <ResponsiveFlexContainer
                        columns={[
                            {
                                content: <p className="is-label">Description</p>,
                                width: firstColumnWidth,
                                isBorder: true,
                            },
                            {
                                content: <p className="is-content">{event.Description}</p>,
                                isBorder: false,
                            },
                        ]}
                    />
                )}
            </EventDetailsWrapper>
            <EventCommentsDocuments
                event={event}
                api="FollowUpID"
                type="FollowUp"
                contactId={event.ModelID}
                drawerMode={!plainMode}
                fetchEvent={handleUpdateFollowUps}
                disableTransaction={plainMode || !event.Project}
                onTransactionCreatedOrUpdated={handleUpdateFollowUps}
                onTouchForm={onTouchForm}
                showOnlyContent
                singleColumnDocuments
                createComments={addCommentForEventId === event.ID}
                afterCommentsCreation={() => dispatch({ type: ACTIONS.SET_ADD_COMMENT_FOR_EVENT, payload: null })}
            />
        </InstanceWrapper>
    );
};

export default FollowUpGroupInstanceDetails;
